import React from 'react';

import WsIconProps from './IconProps';

const NoUserGeneric: React.FC<WsIconProps> = ({ width = '140', height = '140' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="70" cy="70" r="70" fill="#F2FBFD" />
    <path
      d="M32.2051 121.381C28.6147 119.216 22.8496 112.752 28.5126 104.217C35.5914 93.5485 51.1264 90.7478 53.5499 95.0588C55.9734 99.3698 52.9368 106.081 46.863 106.535C40.7892 106.989 30.5454 94.7504 41.1043 79.649C49.5514 67.568 59.7443 63.4524 63.7849 62.9047"
      stroke="#0096C7"
    />
    <path
      d="M69.5108 66.5011L124.235 35.692L83.7895 83.3037L69.5108 66.5011Z"
      fill="white"
      stroke="#90E0EF"
    />
    <path d="M124.003 35.5002L74.5032 71.5063L69.5038 66.0069L124.003 35.5002Z" fill="#E4F7FB" />
    <path d="M69.4233 66.7133L46.0547 38.6796L126.26 34.0005L69.4233 66.7133Z" fill="#3DB9E1" />
    <path
      d="M62.5083 57.3188L59.2395 71.2465L120.848 36.4873L62.5083 57.3188Z"
      fill="white"
      stroke="#90E0EF"
    />
  </svg>
);

export default NoUserGeneric;
